import { Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AppModalConfig } from './modal-config.model';

@Component({
  selector: 'app-modal',
  standalone: false,
  templateUrl: './app-modal.component.html',
  styleUrl: './app-modal.component.scss'
})
export class AppModalComponent {
  @Input() config: AppModalConfig = {};

  @ViewChild('modalTemplate') modalTemplate!: TemplateRef<any>;

  private modalRef!: NgbModalRef;

  constructor(private modalService: NgbModal) {}

  ngOnInit(): void {
    if (this.config.autoOpen) {
      setTimeout(() => this.open());
    }
  }

  open(): void {
    this.modalRef = this.modalService.open(this.modalTemplate, {
      centered: this.config.centered,
      backdrop: this.config.static ? 'static' : true,
      keyboard: this.config.keyboard ?? true,
      windowClass: this.config.windowClass,
      size: this.config.size
    });
  }

  close(): void {
    this.modalRef?.close();
  }

  dismiss(): void {
    this.modalRef?.dismiss();
  }
}
